// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OrganizationNameAndTagLine {\n  white-space: pre;\n}", "",{"version":3,"sources":["webpack://./components/OrganizationNameAndTagLine/index.sass"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":[".OrganizationNameAndTagLine\n  white-space: pre\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
